import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { ModalService, WhiteModal, NoSSR } from '@sm360/widget-commons-general';
import { Modal } from '@sm360/ui-library';
import { Vehicle, Quote } from '@sm360/widget-commons-vehicle';

const InstantEstimateWrapper = lazy(() =>
    import(/* webpackChunkName: "InstantEstimateWrapper" */ 'trade-in/components/InstantEstimateWrapper/InstantEstimateWrapper.jsx')
);

const MODAL_NAME = 'trade-in-estimate-modal';

const InstantEstimateModal = ({
    onClose,
    openModal,
    tradeInVehicle,
    isShowroomV2Enabled,
    quote,
    // TODO: newTradeIn - Remove prop  isDisplayNewTradeIn after deploy new tradeIn to the PROD
    isDisplayNewTradeIn,
    config,
}) => {
    const modal = ModalService.get(MODAL_NAME);
    if (openModal && !modal.isOpen()) {
        modal.open();
    }
    modal.addCallbacks({
        onClose: () => {
            onClose();
            return true;
        },
    });

    return (
        <NoSSR>
            <Suspense fallback="">
                {isDisplayNewTradeIn ? (
                    <Modal
                        isModalOpen={openModal}
                        onClose={onClose}
                        className="widget-sr makes__honda crm"
                        modalScopeCSS="old-trade-in"
                    >
                        {({ setClose }) => (
                            <InstantEstimateWrapper
                                tradeInVehicle={tradeInVehicle}
                                isShowroomV2Enabled={isShowroomV2Enabled}
                                quote={quote}
                                closeModal={setClose}
                                config={config}
                            />
                        )}
                    </Modal>
                ) : (
                    <WhiteModal
                        name={MODAL_NAME}
                        contentLabel="trade-in-modal-label"
                        dataTestPrefix="trade-in.instant-estimate-modal"
                        isScrollable
                        isClosable
                        // TODO: newTradeIn - Remove prop isDisplayNewTradeIn after deploy new tradeIn to the PROD
                        isDisplayNewTradeIn={isDisplayNewTradeIn}
                    >
                        <InstantEstimateWrapper
                            tradeInVehicle={tradeInVehicle}
                            isShowroomV2Enabled={isShowroomV2Enabled}
                            quote={quote}
                            config={config}
                        />
                    </WhiteModal>
                )}
            </Suspense>
        </NoSSR>
    );
};

InstantEstimateModal.defaultProps = {
    openModal: false,
    isDisplayNewTradeIn: false,
    config: {},
};

InstantEstimateModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    openModal: PropTypes.bool,
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel).isRequired,
    isShowroomV2Enabled: PropTypes.bool.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired,
    // TODO: newTradeIn - Remove prop isDisplayNewTradeIn after deploy new tradeIn to the PROD
    isDisplayNewTradeIn: PropTypes.bool,
    config: PropTypes.object,
};

InstantEstimateModal.displayName = 'InstantEstimateModal';
export { MODAL_NAME };
export default InstantEstimateModal;
